import { Reminder, ReminderBasedOn } from '@griply/types';
import * as yup from 'yup';

// A missing anchor defaults to `Start` rather than failing the whole payload —
// external writers (Electron bridge, older clients) may omit it.
export const reminderSchema: yup.ObjectSchema<Reminder> = yup.object({
  id: yup.string().nullable().optional(),
  offset: yup.number().required(),
  basedOn: yup
    .string<ReminderBasedOn>()
    .oneOf(Object.values(ReminderBasedOn))
    .default(ReminderBasedOn.Start)
    .required(),
});
